import { Box, Card, CardHeader, Divider, Grid, Typography } from '@mui/material';
import UserService from '../services/UserService';
import { useEffect } from 'react';
import HttpService from '../services/HttpService';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import CardContent from '@mui/material/CardContent';
import { AaadeIcon, MicrosoftIcon } from '../../src/assets/index';
import React from 'react';
import AsyncBackdropSubmit from '../components/AsyncBackdropSubmit';
import ekome_logo from '../assets/logo_ekome.png';
import { buildRedirectTranslatedUrl } from '../lib/helperFuncs';
import IconCard from '../components/Cards/IconCard';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { decodeRedirectUrl, encodeRedirectUrl } from '../lib/utils';
import google from '../assets/google.svg';
import { taxisRedirect } from './Register';


const Login = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  redirectUriLogin = `${buildRedirectTranslatedUrl()}/location`,
}) => {
  const query = new URLSearchParams(location.search);
  const code = query.get('code');
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const [isTaxisLogining, setIsTaxisLogining] = React.useState(false);
  function getPathFromUrl(url: string) {
    return url.split('?')[0];
  }
  const createSessionFromKeycloak = async (access_token: string) => {
    try {
      const a = await fetch(`${process.env.REACT_APP_KEYCLOAK_SERVER}realms/ekome/gaurav-rest`, {
        credentials: 'include',
        headers:
        {
          'Authorization': `Bearer ${access_token}`
        },
      });
      if (a.status === 204) {
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
    }

  };
  const validateAuthFlowWithTaxis = async () => {
    if (code) {
      setIsTaxisLogining(true);
      try {
        const response = await HttpService.getAxiosClient().post('/users/login/taxisnet', { code });
        const seccessLogin = await createSessionFromKeycloak(response.data.access_token);
        if (seccessLogin) {

          const path = getPathFromUrl(window.location.href);
          window.location.href = path + '#/auth/keycloak/landpage';
        }
      } catch (error) {
        console.error(error);
        enqueueSnackbar(`${t('Αποτυχία Εγγραφής')}`, { variant: 'error' });
      }
      setIsTaxisLogining(false);
    }
  };

  useEffect(() => {
    if (code) {
      validateAuthFlowWithTaxis();
    }
  }, []);

  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirectUrl') || `${process.env.REACT_APP_APP_URL}/location`;


  return (
    <>
      <AsyncBackdropSubmit isLoading={isTaxisLogining}>
        {t('Παρακαλώ περιμένετε, γίνεται επιβεβαίωση των στοιχείων σας')}
      </AsyncBackdropSubmit>
      {!UserService.isAuthenticated() ?
        <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
          {/* <Button variant='contained' onClick={() => alert(UserService.isAuthenticated())}>Auth?</Button> */}
          <Grid item>
            <Card elevation={4}>
              <CardHeader title={
                <>
                  <Typography variant='h2' component='div'
                    sx={{ padding: '8px 0' }}>
                    {t('Συνδεθείτε')}
                  </Typography>
                  <Divider variant='fullWidth' />
                </>
              }>
              </CardHeader>
              <CardContent>
                <IconCard
                  title={t('Email / Κωδικός')}
                  onClick={() => UserService.doLogin({
                    redirectUri: decodeRedirectUrl(redirectTo) || process.env.PUBLIC_URL
                  })}
                  icon={<img src={ekome_logo} alt='EKOME-logo'
                    style={{ maxWidth: '40px', maxHeight: '40px' }} />}
                />
                <IconCard
                  title={'Google'}
                  onClick={() => UserService.doLogin({
                    idpHint: 'google',
                    redirectUri: `${buildRedirectTranslatedUrl()}/auth/keycloak/landpage?redirectUrl=${encodeRedirectUrl(redirectTo)}`
                  })}
                  icon={<img src={google} alt='mySvgImage' />}
                />
                {/* <IconCard
                  title={'Facebook'}
                  onClick={() => UserService.doLogin({
                    idpHint: 'facebook',
                    redirectUri: `${buildRedirectTranslatedUrl()}/auth/keycloak/landpage?redirectUrl=${decodeRedirectUrl(redirectTo)}`
                  })}
                  icon={<FacebookIcon sx={{ fontSize: '40px' }} />}
                /> */}
                <IconCard
                  title={'Microsoft'}
                  onClick={() => UserService.doLogin({
                    idpHint: 'public-microsoft',
                    redirectUri: `${buildRedirectTranslatedUrl()}/auth/keycloak/landpage?redirectUrl=${encodeRedirectUrl(redirectTo)}`
                  })}
                  icon={<MicrosoftIcon sx={{ fontSize: '40px' }} />}
                />
                <IconCard
                  title={'Taxisnet'}
                  onClick={taxisRedirect}
                  icon={<AaadeIcon sx={{ color: 'black', fontSize: '40px' }} />}
                />
                <Box display='flex' justifyContent='end'
                  mt={3} >
                  <Typography mr={1} variant='h4'>
                    {t('Δεν έχετε λογαριασμό;')}
                  </Typography>
                  <Link to={`/register?redirectUrl=${redirectTo}`}
                  ><Typography variant='h4'>{t('Εγγραφή')}</Typography></Link>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid >

        : <Box mt={3}>
          <Navigate to='/location' />
        </Box>
      }
    </>
  );
};

export default Login;
